import React from "react";
import { Icon, UserAvatar } from "../../components/Component";
import { Link, useLocation } from "react-router-dom";

const WorkBoqAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  // Get current pathname without query params for comparison
  const pathname = location.pathname;
  const pathWithoutPrefix = pathname.replace(process.env.PUBLIC_URL || "", "");

  // Helper function to check if a route is active
  const isActive = (route: string) => {
    const routePath = route.replace(process.env.PUBLIC_URL || "", "");
    // Exact match
    if (pathWithoutPrefix === routePath) return true;
    // For view pages with IDs, highlight the list page
    if (routePath === "/work-boq-list" && pathWithoutPrefix.startsWith("/work-boq-view/")) return true;
    if (routePath === "/work-boq-creation" && pathWithoutPrefix.startsWith("/work-boq-creation")) return true;
    return false;
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          {/* <UserAvatar size="lg" theme="primary" text="WB" /> */}
          <div className="user-info">
            <span className="lead-text">BOQ</span>
            <span className="sub-text">Bill of Quantities for Work Orders</span>
          </div>
          {/* <div className="user-action">
            <div className="dropdown">
              <a
                href="#"
                className={`btn btn-icon btn-trigger mr-n2 ${
                  sm ? "active" : ""
                }`}
                onClick={(ev) => {
                  ev.preventDefault();
                  updateSm(!sm);
                }}
              >
                <Icon name="more-v" />
              </a>
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt">Work BOQ Management</h6>
          <div className="user-balance">
            <div className="user-balance-sub">
              <Icon name="briefcase" />
              <span>Create and manage work scope definitions</span>
            </div>
          </div>
        </div>
      </div> */}
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li className={isActive(`${process.env.PUBLIC_URL}/work-boq-creation`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-creation${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-round-fill" />
              <span>Create BOQ</span>
            </Link>
          </li>
          <li className={isActive(`${process.env.PUBLIC_URL}/work-boq-approvals`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle-fill" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li className={isActive(`${process.env.PUBLIC_URL}/work-boq-list`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-list${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="list-fill" />
              <span>View BOQ List</span>
            </Link>
          </li>

          {/* <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-boq-reports`}
              onClick={() => updateSm(false)}
            >
              <Icon name="reports" />
              <span>Work BOQ Reports</span>
            </Link>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default WorkBoqAside;
